import { Component, OnInit, Input } from '@angular/core';
import * as $ from 'jquery';
import { Subject, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'cli-backflow-tooltip-modal',
  templateUrl: './backflow-tooltip-modal.component.html',
  styleUrls: ['./backflow-tooltip-modal.component.scss']
})
export class BackflowTooltipModalComponent implements OnInit {

    private subject: Subject<string>;
  
    @Input()
    public id: string;
    @Input()
    public message: string;
    @Input()
    public header: string;
  
    constructor() {
  
      this.header = environment.MODAL_HEADER;
      this.id = 'backflowTooltipModal';
    }
  
    ngOnInit() {
    }
  
    public openModal(): Observable<string> {
  
      $(`#${this.id}`).modal();
  
      this.subject = new Subject<string>();
  
      return this.subject.asObservable();
    }
  
    public proceedYes() {
  
  
      this.closeModal();
  
      this.subject.next('Yes');
      this.subject.complete();
    }
  
    public proceedCancel() {
      this.closeModal();
  
      this.subject.next('Cancel');
      this.subject.complete();
    }
  
    public closeModal() {
      $('#' + this.id).modal('hide');     
    }
  
  }
  
